import { useClient } from '@composables/use-clients';
import {
  PostRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PublishReviewArgsType = PostRequestArgsType<any> & {
  reviewCode: string;
};

export const apiPublishReview = async ({
  domain = useTenantStore().domain,
  reviewCode,
  errorConfig = {},
  callbacks = {},
}: PublishReviewArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.reviewPublish({ domain, reviewCode }),
      payload: {},
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
